import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import useFetchApiData from '../helper/useFetchApiData';
import { addToCart } from '../helper/cartfunction';
const calculateDiscountedPrice = (price, discount, discountType) => {
    if (discountType === 'amount') {
        return price - discount;
    }
    if (discountType === 'percent') {
        return price - (price * discount) / 100;
    }
    return price;
};

const NewArrivalOne = () => {
    const latestArrival = useFetchApiData('/products/latest');
    

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            { breakpoint: 1599, settings: { slidesToShow: 6 } },
            { breakpoint: 1399, settings: { slidesToShow: 4 } },
            { breakpoint: 992, settings: { slidesToShow: 3 } },
            { breakpoint: 575, settings: { slidesToShow: 2 } },
            { breakpoint: 424, settings: { slidesToShow: 1 } },
        ],
    };

    return (
        <section className="new-arrival pb-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">You May Also Like</h5>
                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                All Products
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="new-arrival__slider arrow-style-two">
                    <Slider {...settings}>
 
                        {latestArrival.products?.map((product) => {
                            const discountedPrice = calculateDiscountedPrice(
                                product.price,
                                product.discount,
                                product.discount_type
                            );

                            return (
                                <div key={product.id}>
                                    <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                                        {product.discount > 0 && (
                                            <span className="product-card__badge bg-info-600 px-8 py-4 text-sm text-white">
                                                {product.discount_type === 'amount'
                                                    ? `Save Rs.${product.discount}`
                                                    : `Save ${product.discount}%`}
                                            </span>
                                        )}
                                        <Link
                                            to={`/product-details/${product.id}`}
                                            className="product-card__thumb flex-center"
                                        >
                                            <img src={product.image_fullpath[0]} alt={product.name} />
                                        </Link>
                                        <div className="product-card__content p-sm-2">
                                            <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                <Link
                                                    to={`/product-details/${product.id}`}
                                                    className="link text-line-2"
                                                >
                                                    {product.name}
                                                </Link>
                                            </h6>
                                            <div className="product-card__price mb-8">
                                                <span className="text-heading text-md fw-semibold">
                                                    Rs. {discountedPrice.toFixed(2)}{' '}
                                                    <span className="text-gray-500 fw-normal">
                                                    </span>
                                                </span>
                                                {discountedPrice < product.price && (
                                                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                                        Rs. {product.price.toFixed(2)}
                                                    </span>
                                                )}
                                            </div>
                                            <button
                                                onClick={()=>{addToCart(product.id,1)}}
                                                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
                                            >
                                                Add To Cart <i className="ph ph-shopping-cart" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

export default NewArrivalOne;
